import { useEffect, useMemo, useState } from "react";
import { Cell, useBlockLayout, useFilters, useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import { BuildingFacilityTagModel, BuildingFacilityTagParams } from "src/api/building/commonfacility-types";
import { BaseButton, BaseCheckbox, BaseInput } from "src/components";
import useFacilityTag from "src/pages/building/hooks/useFacilityTag";

const columns: any[] = [
  {
    Header: "id",
    accessor: "id",
    width: 60,
  },
  {
    Header: "태그명",
    accessor: "name",
    width: 560,
    Cell: ({ value }: Cell<BuildingFacilityTagModel>) => {
      return <div className="facility-tag-color">{value}</div>;
    },
  },
];

type Props = {
  onClose: () => void;
  serviceId: string;
  selectedIdList: string[];
  onSelectList: (selectedTagList: BuildingFacilityTagModel[]) => void;
};

const FacilityTagSelectList = ({ onClose, serviceId, onSelectList, selectedIdList }: Props) => {
  // 검색 키워드 구현하기
  const [keyword, setKeyword] = useState<string>("");

  const [tagList, setTagList] = useState<Array<any>>([]);

  // 체크박스된 데이터
  const [selectedItems, setSelectedItems] = useState<Array<any & { checked: boolean }>>([]);

  // 태그 목록 조회
  const { getFacilityTagList } = useFacilityTag();

  const fetchTagList = async (searchParams?: BuildingFacilityTagParams) => {
    const tags = await getFacilityTagList(searchParams);
    setTagList(tags);
  };
  useEffect(() => {
    fetchTagList();
  }, []);

  const tableData = useMemo(
    () =>
      tagList.map((item) => {
        const selects = selectedItems.map((select: any) => Number(select.id));
        return {
          checked: selects.includes(Number(item.id)) || selectedIdList.includes(String(item.id)),
          ...item,
        };
      }),
    [selectedItems, tagList],
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = useTable(
    {
      columns: columns,
      data: tableData,
    },
    useBlockLayout,
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns: Array<any>) => [
        {
          width: 80,
          Header: "선택",
          accessor: "checked",
          Cell: ({ row }: Cell<BuildingFacilityTagModel & { checked: boolean }>) => {
            return (
              <div>
                <BaseCheckbox
                  id={`tag ${row.original.id}`}
                  name={`tag ${row.original.id}`}
                  checked={row.original.checked}
                  disabled={selectedIdList.includes(String(row.original.id))}
                  onChange={(checked: boolean) => {
                    row.original.checked = checked;
                    if (checked) {
                      const data = row.original;
                      setSelectedItems((prev) => [...prev, data]);
                    } else {
                      setSelectedItems((prev) => prev.filter((item) => item.id !== row.original.id));
                    }
                  }}
                />
              </div>
            );
          },
        },
        ...columns,
      ]);
    },
  );

  const tableWidth = useMemo(() => {
    let totalWidth = 0;
    headerGroups.forEach((headerGroup) => {
      headerGroup.headers.forEach((header) => (totalWidth += Number(header?.width || 0)));
    });
    return totalWidth;
  }, [headerGroups]);
  return (
    <>
      {/*table */}
      <section className="base-abstract-modal__title flex-center-between ">
        <h1>태그 선택</h1>
        <div className="right-area">
          <div className="minmax240">
            {/* <BaseInput
              onChange={setKeyword}
              value={keyword}
              onSearchClick={() => {
                fetchTagList({ searchValue: keyword });
              }}
            /> */}
          </div>
        </div>
      </section>
      <section className="base-abstract-modal__contents ">
        <div className="contents-container__table px30 ">
          <div {...getTableProps()} className="base-table view-data-table sticky">
            <div className="header">
              {headerGroups.map((headerGroup) => (
                <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                  {headerGroup.headers.map((header) => {
                    return (
                      <div {...header.getHeaderProps()} className="base-table__th">
                        {header.render("Header")}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
            <div {...getTableBodyProps()} className="body">
              {rows.length > 0 ? (
                rows.map((row, idx: number) => {
                  prepareRow(row);
                  return (
                    <div {...row.getRowProps()} className="base-table__tr">
                      {row.cells.map((cell) => {
                        return (
                          <div {...cell.getCellProps()} className="base-table__td">
                            {cell.render("Cell")}
                          </div>
                        );
                      })}
                    </div>
                  );
                })
              ) : (
                <div className="base-table__tr table-cursor-unset" style={{ width: tableWidth }}>
                  <div className="base-table__td w-100 text-center">
                    <div className="w-100">
                      <span>데이터가 없습니다.</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <BaseButton className="color-white" title="닫기" onClick={onClose} />
        <BaseButton
          title="선택"
          onClick={() => {
            onSelectList(selectedItems);
            onClose();
            setSelectedItems([]);
          }}
        />
      </section>
    </>
  );
};
export default FacilityTagSelectList;
